import { Component, OnDestroy, OnInit } from '@angular/core';
import { HxAuthService, NotifierService } from 'hx-services';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [NgIf, RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    public auth: HxAuthService,
    private notifierService: NotifierService,
  ) {
  }

  ngOnInit(): void {
    this.notifierService.start();
  }

  ngOnDestroy(): void {
    this.notifierService.destroy();
  }
}
